import React from "react";
import Table from 'react-bootstrap/Table';
import FilterRow from "./FilterRow";
import TableRow from "./TableRow";
import TableHeader from "./TableHeader";
import "./_static/TableView.css"

function TableView(props) {

    const actions = props.actions ? props.actions : ['Delete']

    function getClassName() {
        let newClassName = "fullWidthTable"
        if (props.noColorRows) {
            newClassName += " noColorRows"
        }
        return newClassName
    }

    return (
        <div className="tableDiv">
            {props.label && <h2 className="mb-3">{props.label}</h2>}
            <Table striped bordered hover responsive className={getClassName()}>
                <TableHeader filterUpdate={props.filterUpdate} headers={props.headers} actions={actions}/>
                <tbody className="table-body">
                {props.filters ? <FilterRow filters={props.filters} filterUpdate={props.filterUpdate}
                                            headers={props.headers} actions={actions}/> : null}
                {props.data ? props.data.map((row, index) => (
                    <TableRow links={props.links[index]} key={index} index={index} row={row} headers={props.headers}
                              actions={actions} delete_single={props.delete_single}
                              deleteConfirmationText={props.deleteConfirmationText}
                              deleteConfirmation={props.deleteConfirmation}/>
                )) : null}
                </tbody>
            </Table>
        </div>
    )
}

TableView.defaultProps = {
    links: []
};
export default TableView
